import pino from 'pino';

// Credentials that must never reach a log sink. `remove: true` drops the key
// entirely. The token paths are a backstop for the masking in auth-options.ts
// (COMP-52): if a raw token is ever logged again, pino strips it.
export const LOG_REDACT_PATHS = [
  `req.headers.Authorization`,
  `req.headers.authorization`,
  `req.headers.cookie`,
  `jwt.accessToken`,
  `token.accessToken`,
  `account.access_token`,
  `account.id_token`,
  `account.refresh_token`,
];

const logger = pino({
  level: process.env.LOG_LEVEL || `info`,
  redact: {
    paths: LOG_REDACT_PATHS,
    censor: `[REDACTED]`,
    remove: true,
  },
});

export default logger;
